import JalanExperience from './JalanExperience/JalanExperience';

// reservationページのじゃらん体験
if (document.querySelector('[name="jalan-form"]') !== null) {
  // eslint-disable-next-line no-new
  new JalanExperience({
    requestBaseURI: '/jalan_experiences',
    prefId: '400000', // kenCd
    areaId: '400100', // lrgCd
    // cityId: '342020000', // cityCd
    itemSizePerPage: 24,
    initPageNum: 1,
    sortType: 1,
    view: {
      noImagePath: document.querySelector('[data-role="jalan-no-img-path"]').src,
      sortButtonActiveClassName: 'is-active',
      hideClassName: 'd-none',
    },
  });
}
